import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';

export const DatenschutzPage = () => {
  return (
    <>
      <Helmet>
        <title>Datenschutzerklärung | M.A. Zulassungsdienst Velbert</title>
        <meta name="description" content="Datenschutzerklärung von M.A. Zulassungsdienst - Informationen zur Datenverarbeitung gemäß DSGVO" />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="min-h-screen overflow-x-hidden">
        <Header />
        <main className="pt-32 pb-20 px-4 sm:px-10 md:px-20 bg-white">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl sm:text-5xl font-bold mb-8 text-[#0D0D0D]">Datenschutzerklärung</h1>
            
            <div className="prose prose-lg max-w-none">
              <p className="text-lg mb-6">
                Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten 
                daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2021). In dieser 
                Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im 
                Rahmen unserer Website.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">1. Verantwortlicher</h2>
              <p className="mb-4">
                <strong>M.A. Zulassungsdienst</strong><br/>
                Inhaber: Mazlum Aksu<br/>
                Kamperstraße 8<br/>
                42555 Velbert<br/>
                E-Mail: <a href="mailto:kontakt@mazulassungsdienst.de" className="text-[#006B3F] hover:underline">kontakt@mazulassungsdienst.de</a><br/>
                Telefon: <a href="tel:015159182828" className="text-[#006B3F] hover:underline">0151 59182828</a>
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">2. Hosting und technische Bereitstellung</h2>
              <p className="mb-4">
                Diese Website wird über die <strong>Emergent Platform</strong> bereitgestellt. Dabei werden 
                folgende Daten technisch erfasst:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>IP-Adresse des Besuchers</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Besuchte Seiten und übertragene Datenmenge</li>
                <li>Browser-Typ und Version</li>
                <li>Betriebssystem</li>
              </ul>
              <p className="mb-4">
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der technischen 
                Bereitstellung und Sicherheit der Website)
              </p>
              <p className="mb-4">
                <strong>Aufbewahrungsdauer:</strong> Die Daten werden gelöscht, sobald sie für die Zweckerreichung 
                nicht mehr erforderlich sind, in der Regel nach 7 Tagen.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">3. Kontaktformular und E-Mail-Kontakt</h2>
              <p className="mb-4">
                Wenn Sie uns per Kontaktformular oder E-Mail Anfragen zukommen lassen, werden Ihre Angaben aus der 
                Anfrage inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für 
                den Fall von Anschlussfragen bei uns gespeichert.
              </p>
              <p className="mb-4">
                <strong>Verarbeitete Daten:</strong>
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Name</li>
                <li>E-Mail-Adresse</li>
                <li>Telefonnummer (optional)</li>
                <li>Nachrichteninhalt</li>
                <li>Gewählte Dienstleistung</li>
                <li>Zeitpunkt der Anfrage</li>
              </ul>
              <p className="mb-4">
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Ihre Einwilligung) und Art. 6 Abs. 1 
                lit. b DSGVO (Verarbeitung zur Erfüllung eines Vertrags bzw. vorvertraglicher Maßnahmen)
              </p>
              <p className="mb-4">
                <strong>Datenspeicherung:</strong> Ihre Anfragedaten werden in einer MongoDB-Datenbank gespeichert 
                und per E-Mail (SMTP) an unsere Geschäfts-E-Mail gesendet.
              </p>
              <p className="mb-4">
                <strong>Aufbewahrungsdauer:</strong> Ihre Daten werden nach Abschluss der Bearbeitung gelöscht, 
                sofern keine gesetzlichen Aufbewahrungspflichten bestehen (z.B. steuerrechtliche Aufbewahrungsfristen 
                von bis zu 10 Jahren bei Geschäftsvorgängen).
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">4. WhatsApp-Kontakt</h2>
              <p className="mb-4">
                Auf unserer Website bieten wir die Möglichkeit, uns direkt über WhatsApp zu kontaktieren. Wenn Sie 
                auf den WhatsApp-Button klicken, werden Sie zu WhatsApp weitergeleitet.
              </p>
              <p className="mb-4">
                <strong>Wichtiger Hinweis:</strong> Durch das Anklicken des WhatsApp-Buttons verlassen Sie unsere 
                Website und werden zu WhatsApp weitergeleitet. WhatsApp ist ein Dienst der Meta Platforms Ireland 
                Limited. Für die Verarbeitung Ihrer Daten durch WhatsApp gelten die Datenschutzbestimmungen von Meta.
              </p>
              <p className="mb-4">
                Wir haben keinen Einfluss auf Art und Umfang der durch WhatsApp verarbeiteten Daten und deren 
                Verwendung. Weitere Informationen finden Sie in der Datenschutzerklärung von WhatsApp: 
                <a href="https://www.whatsapp.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#006B3F] hover:underline">
                  https://www.whatsapp.com/legal/privacy-policy
                </a>
              </p>
              <p className="mb-4">
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Ihre Einwilligung durch aktives Anklicken)
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">5. Schriftarten</h2>
              <p className="mb-4">
                Diese Website verwendet lokal gespeicherte Webfonts (Inter, Bebas Neue, Montserrat). Die Schriftarten 
                werden direkt von unserem Server geladen. Es erfolgt keine Verbindung zu externen Diensten wie Google Fonts. 
                Ihre Daten werden nicht an Dritte übermittelt.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">6. eVB-Nummer, Versicherungs- und Finanzanlagenvermittlung</h2>
              <p className="mb-4">
                Wenn Sie über unsere Website eine Anfrage zu einer eVB-Nummer, Kfz-Versicherung oder Finanzanlage stellen, werden 
                Ihre Daten an die <strong>HDI Hauptvertretung Mazlum Aksu</strong> weitergeleitet.
              </p>
              <p className="mb-4">
                Die HDI Hauptvertretung ist rechtlich eigenständig und verarbeitet Ihre Daten eigenverantwortlich 
                zur Bearbeitung Ihrer Versicherungs- oder Finanzanlageanfrage. Es gelten die Datenschutzbestimmungen der HDI.
              </p>
              <p className="mb-4">
                <strong>Empfänger:</strong><br/>
                HDI Hauptvertretung Mazlum Aksu<br/>
                Kamper Str. 8, 42555 Velbert<br/>
                Telefon: 02052 8352655<br/>
                E-Mail: <a href="mailto:mazlum.aksu@hdi.de" className="text-[#006B3F] hover:underline">mazlum.aksu@hdi.de</a><br/>
                Website: <a href="https://www.hdi.de/betreuer/mazlum-aksu/" target="_blank" rel="noopener noreferrer" className="text-[#006B3F] hover:underline">www.hdi.de/betreuer/mazlum-aksu/</a>
              </p>
              <p className="mb-4">
                <strong>Registrierungen:</strong><br/>
                Gebundener Versicherungsvertreter (§ 34d Abs. 7 GewO)<br/>
                Finanzanlagenvermittler (§ 34f Abs. 1 Satz 1 Nr. 1 GewO)<br/>
                Vermittlerregister: D-G9R0-U54P-W-49
              </p>
              <p className="mb-4">
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Verarbeitung zur Durchführung 
                vorvertraglicher Maßnahmen)
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">7. Ihre Rechte</h2>
              <p className="mb-4">
                Ihnen stehen grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, 
                Datenübertragbarkeit, Widerruf und Widerspruch zu. Wenn Sie glauben, dass die Verarbeitung Ihrer 
                Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst in einer 
                Weise verletzt worden sind, können Sie sich bei der Aufsichtsbehörde beschweren.
              </p>
              <p className="mb-4">
                <strong>Zuständige Aufsichtsbehörde:</strong><br/>
                Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen<br/>
                Kavalleriestraße 2-4<br/>
                40213 Düsseldorf<br/>
                <a href="https://www.ldi.nrw.de" target="_blank" rel="noopener noreferrer" className="text-[#006B3F] hover:underline">
                  www.ldi.nrw.de
                </a>
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3 text-[#0D0D0D]">Auskunftsrecht</h3>
              <p className="mb-4">
                Sie haben das Recht, jederzeit Auskunft über die von uns über Sie gespeicherten Daten zu erhalten.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3 text-[#0D0D0D]">Widerrufsrecht</h3>
              <p className="mb-4">
                Sie haben das Recht, Ihre Einwilligung zur Datenverarbeitung jederzeit zu widerrufen. Der Widerruf 
                berührt die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung nicht.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3 text-[#0D0D0D]">Widerspruchsrecht</h3>
              <p className="mb-4">
                Sie haben das Recht, gegen die Verarbeitung Ihrer personenbezogenen Daten Widerspruch einzulegen, 
                sofern die Verarbeitung auf Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse) beruht.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3 text-[#0D0D0D]">Löschung</h3>
              <p className="mb-4">
                Sie haben das Recht auf Löschung Ihrer bei uns gespeicherten Daten, soweit nicht gesetzliche 
                Aufbewahrungspflichten oder andere gesetzliche Pflichten einer Löschung entgegenstehen.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">8. Datensicherheit</h2>
              <p className="mb-4">
                Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) in 
                Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird. 
                Ob eine einzelne Seite unseres Internetauftrittes verschlüsselt übertragen wird, erkennen Sie an der 
                geschlossenen Darstellung des Schlosssymbols in der Statusleiste Ihres Browsers.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#0D0D0D]">9. Änderungen dieser Datenschutzerklärung</h2>
              <p className="mb-4">
                Wir behalten uns vor, diese Datenschutzerklärung gelegentlich anzupassen, damit sie stets den 
                aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der 
                Datenschutzerklärung umzusetzen.
              </p>

              <p className="mt-8 text-sm text-gray-600">
                <strong>Stand:</strong> November 2026
              </p>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};
